export default "__VITE_ASSET__a3kimN_0__";